import React, { useState, forwardRef } from "react";
import { Autocomplete, useLoadScript } from "@react-google-maps/api";
import { Map, GoogleApiWrapper, Marker,InfoWindow ,Google } from 'google-maps-react';
const placesLibrary = ["places"];

function GetAddress({parentCallback}) {
  const [searchResult2, setSearchResult1] = useState("Result: none");

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyC8h_mvGDzcKMbco8ouhimrHCXQEQpc--M",
    libraries: placesLibrary,
  });

  function onLoad(autocomplete) {
    var options = {
      types: ["(cities)"],
      componentRestrictions: { country: "IN" , postalCode: "530068",},
    };
 

 

    setSearchResult1(autocomplete);
  }

  function onPlaceChanged() {
    if (searchResult2 != null) {
      const place = searchResult2.getPlace();
      const name = place.name;
      const status = place.business_status;
      const formattedAddress = place.formatted_address;
      // console.log(place);
	  
	  parentCallback(place.geometry.location.lat()+ "~" +place.geometry.location.lng()+"~"+place.formatted_address);          
   
      console.log(`Name: ${name}`);
      console.log(`Business Status: ${status}`);
      console.log(`Formatted Address: ${formattedAddress}`);
    } else {
      alert("Please enter text");
    }
  }

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <div className="App">
      <div id="searchColumn">
     
        <Autocomplete onPlaceChanged={onPlaceChanged} onLoad={onLoad}
		searchOptions={{ types: [ 'IN'] }}
		>
          <input
            type="text"
            placeholder="Location Search"
            style={{
              boxSizing: `border-box`,
              border: `1px solid transparent`,
              width: `240px`,
              height: `32px`,
              padding: `0 12px`,
              borderRadius: `3px`,
              boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
              fontSize: `14px`,
              outline: `none`,
              textOverflow: `ellipses`,
            }}
          />
        </Autocomplete>
      </div>
    </div>
  );
}

export default GetAddress;
